const API_URL = "https://app.tavad.com/hce/wp-json/wp/v2";

export async function getAllTratamientos() {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/users`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getTratamientoBySlug(slug) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/tratamiento?slug=${slug}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getTratamientoById(tratamientoId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/tratamiento/${tratamientoId}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getTratamientoByIds(tratamientoIds) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/tratamientos?include=${tratamientoIds}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getTratamientoByIdsByEspecialista(tratamientoIds, especialistaId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/tratamientos?include=${tratamientoIds}&especialista=${especialistaId}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}
